import { NotImplementedError } from "../../../../../errors";
import { parseDealIdOptionsResponse } from "../../../../../models/looker/modules/bidstream/dealIds";
import { PromiseHandler } from "../../../../../handlers";
import { DealIdOptionsFetchFailed } from "./errors";
import { buildDealIdOptionsQuery } from "./query";
/**
 * Filters by line item, optionally by date range. See dealIds.ts in
 * models/looker/modules/bidstream for the query and why it serves both
 * the dropdown's items and its disabled/tooltip check.
 */
class DealIdOptions extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-bidstream-deal-id-options");
    }
    async findItems(filters) {
        const lineItemId = filters.where?.find((filter) => filter.field === "lineItemId")?.value;
        const datesFilterField = filters.where?.find((filter) => filter.field === "dates");
        const forceRefresh = filters.where?.find((filter) => filter.field === "forceRefresh")?.value === true;
        if (typeof lineItemId !== "string" || !lineItemId) {
            throw new Error("lineItemId filter is required");
        }
        // No default here, unlike the other handlers: an *omitted* dates
        // filter means the full history check, not a default window. A dates
        // filter that IS present but malformed is a caller bug, not a request
        // for history - reject it instead of silently widening the query to
        // the broadest possible result.
        let dates;
        if (datesFilterField !== undefined) {
            const datesFilter = datesFilterField.value;
            if (!Array.isArray(datesFilter) ||
                datesFilter.length !== 2 ||
                // `new Date("invalid")` is still a Date instance - check it also
                // parsed to a real timestamp, since Looker would otherwise get
                // formatDayRange's "Invalid DateTime" instead of a real filter.
                !datesFilter.every((date) => date instanceof Date && !Number.isNaN(date.getTime()))) {
                throw new Error("dates filter, when provided, must be a two-element Date array");
            }
            dates = datesFilter;
        }
        const queryBody = buildDealIdOptionsQuery(lineItemId, dates);
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        // This removes the cache entry for this exact query. This makes sure
        // the Refresh button always sends a new request to the network.
        // Without this, the Refresh button could show an old cached result.
        // See the same comment on Bidstream.findItems in ../index.ts.
        if (forceRefresh) {
            this.cache.remove(hashKey);
        }
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: parseDealIdOptionsResponse(data),
                queryMeta
            }
        ])
            .catch((error) => {
            throw new DealIdOptionsFetchFailed(error);
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
export default DealIdOptions;
//# sourceMappingURL=index.js.map